import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureStrict } from '../lib/features';
import { useStore } from '../store/StoreContext';
import { registerWebMcpTools } from '../lib/webmcp';

// Mounts the WebMCP tools only on public routes while the webmcp.v1 flag is
// explicitly on. Re-registers when the session changes, unregisters on
// leaving the route. Renders nothing; unsupported browsers are a no-op.
export function WebMcpBridge() {
  const enabled = useFeatureStrict('webmcp.v1');
  const { isLoggedIn } = useStore();
  const onPublicRoute = useLocation().pathname.startsWith('/public');
  useEffect(() => {
    if (!enabled || !onPublicRoute) return;
    return registerWebMcpTools();
  }, [enabled, onPublicRoute, isLoggedIn]);
  return null;
}
